export const DIGITAL_CHANNEL_IDS = [
  "DOUYIN",
  "XHS",
  "BAIDU",
  "WECHAT",
  "TRANSACTION",
  "OWNED_SITE",
];

export const CHANNEL_STRATEGY_CONTRACTS = {
  DOUYIN: {
    name: "抖音",
    stage: "看到你 → 采取行动",
    role: "用短视频与直播建立兴趣，并推动一次可识别的下一动作。",
    entry: "场景内容、直播或达人触达",
    exit: "搜索品牌、进入主页、私信、留资或商品入口",
    content: [
      ["主题", "真实问题场景、产品演示、选择证据"],
      ["形式", "短视频、直播切片、达人共创"],
      ["证据", "可复核演示、案例、参数与承诺边界"],
      ["CTA", "搜索品牌词、进入承接页或完成留资"],
      ["测试批次", "3 个主题 × 2 类证据，分批观察有效进入"],
    ],
    paid: [
      ["目标", "有效进入或有效客户，不以播放量作为结果"],
      ["人群", "问题人群、高相关兴趣人群与已验证相似人群"],
      ["素材矩阵", "问题场景 × 证据类型 × CTA"],
      ["预算上限", "单批封顶，达到质量护栏后才增加"],
      ["排除条件", "低质量互动、重复曝光和已证伪人群"],
    ],
    metric: "有效进入成本",
    guardrail: "退款、毛利或有效成交质量",
    stop: "成本改善但成交质量、利润或退款护栏恶化",
  },
  XHS: {
    name: "小红书",
    stage: "理解你 → 相信你",
    role: "用可搜索的经验和比较内容，帮助客户理解并建立可信度。",
    entry: "问题词、品类词、场景词与推荐流",
    exit: "品牌搜索、主页、私信、官网或交易入口",
    content: [
      ["主题", "选择标准、使用体验、产品比较"],
      ["形式", "图文笔记、短视频、用户共创"],
      ["证据", "可复核体验、参数、案例与适用边界"],
      ["CTA", "收藏、搜索品牌词或进入承接页"],
      ["测试批次", "问题词簇 × 内容证据分批验证"],
    ],
    paid: [
      ["目标", "高意向搜索进入与有效咨询"],
      ["人群", "品类搜索、问题搜索和相似需求人群"],
      ["素材矩阵", "问题词 × 场景 × 证据"],
      ["预算上限", "自然验证后再放大高质量词簇"],
      ["排除条件", "泛兴趣、无关词与低质量互动"],
    ],
    metric: "品牌搜索或有效咨询成本",
    guardrail: "咨询质量、成交贡献与投诉",
    stop: "搜索和互动增加，但有效咨询或成交质量无改善",
  },
  BAIDU: {
    name: "百度",
    stage: "主动寻找 → 采取行动",
    role: "承接已经明确表达需求的人，并连接到一次有效咨询或交易。",
    entry: "问题词、品类词、品牌词和比较词",
    exit: "官网、咨询、电话、表单或交易页",
    content: [
      ["主题", "问题答案、选择标准、方案与案例"],
      ["形式", "搜索落地页、问答与专题页"],
      ["证据", "来源、日期、案例边界和产品事实"],
      ["CTA", "咨询、试用、到店或购买"],
      ["测试批次", "按词簇意图和落地页分组"],
    ],
    paid: [
      ["目标", "有效咨询或有效成交"],
      ["人群", "明确需求词、竞品比较词与品牌词"],
      ["素材矩阵", "词簇 × 诉求 × 落地页"],
      ["预算上限", "按有效动作封顶，不按点击量扩量"],
      ["排除条件", "否定词、无关地区和低质时段"],
    ],
    metric: "有效搜索客户成本",
    guardrail: "有效咨询率、毛利与无效线索率",
    stop: "点击成本下降，但有效咨询或成交贡献恶化",
  },
  WECHAT: {
    name: "微信生态",
    stage: "相信你 → 再次选择",
    role: "持续解释复杂价值，承接咨询，并支持复购或续约。",
    entry: "公众号、视频号、企微、小程序或社群",
    exit: "咨询、预约、交易、复购或续约",
    content: [
      ["主题", "深度解释、案例复核、服务与关系维护"],
      ["形式", "文章、视频号、直播与企微沟通"],
      ["证据", "客户案例、服务记录和持续价值证据"],
      ["CTA", "咨询、预约、复购或续约"],
      ["测试批次", "按客户阶段和内容任务分组"],
    ],
    paid: [
      ["目标", "高质量承接与再次选择"],
      ["人群", "已识别客户、相似人群与存量客户"],
      ["素材矩阵", "客户阶段 × 证据 × 服务动作"],
      ["预算上限", "承接和响应能力验证后再增加触达"],
      ["排除条件", "无授权触达、重复骚扰与无效人群"],
    ],
    metric: "有效咨询、复购或续约率",
    guardrail: "退订、投诉、响应成本与留存",
    stop: "触达增加，但退订、投诉或客户质量恶化",
  },
  TRANSACTION: {
    name: "平台交易",
    stage: "采取行动 → 完成购买",
    role: "缩短从意向到支付的路径，并用真实交易验证客户质量。",
    entry: "商品页、活动页、店铺搜索或外部导流",
    exit: "支付、退款、评价与复购",
    content: [
      ["主题", "商品价值、选择证据、履约与风险说明"],
      ["形式", "商品页、详情页、评价和直播货架"],
      ["证据", "参数、评价、履约和售后边界"],
      ["CTA", "加购、下单或复购"],
      ["测试批次", "商品 × 人群 × 权益组合"],
    ],
    paid: [
      ["目标", "有效支付与贡献利润"],
      ["人群", "高意向访问和相似购买人群"],
      ["素材矩阵", "商品 × 场景 × 权益 × 证据"],
      ["预算上限", "以贡献和退款护栏限制扩量"],
      ["排除条件", "高退款人群与低毛利组合"],
    ],
    metric: "有效支付客户成本",
    guardrail: "退款、毛利、履约与复购",
    stop: "支付增加，但退款、毛利或履约风险恶化",
  },
  OWNED_SITE: {
    name: "官网 / SEO / GEO",
    stage: "理解你 → 相信你 → 采取行动",
    role: "用可引用的结构化证据承接搜索与 AI 引荐，并连接到有效动作。",
    entry: "问题词对应的官网专题页、案例页与咨询入口",
    exit: "案例阅读、下载、咨询、试用或交易",
    content: [
      ["主题", "问题词簇、实体事实、能力证据与案例"],
      ["形式", "专题页、案例页、FAQ 和结构化数据"],
      ["证据", "清晰实体、原始来源、日期与边界"],
      ["CTA", "咨询、试用、下载或购买"],
      ["测试批次", "问题词簇 × 证据页面 × CTA"],
    ],
    paid: [
      ["目标", "有效自然 / AI 引荐与咨询"],
      ["人群", "高意向搜索与 AI 问答用户"],
      ["素材矩阵", "词簇 × 页面任务 × 证据"],
      ["预算上限", "按有效引荐和商机复核内容投入"],
      ["排除条件", "无证据声明、重复薄内容与错误实体"],
    ],
    geo: [
      ["问题词簇", "业务问题词、品类词、比较词与品牌实体词"],
      ["实体与证据", "企业、产品、能力、案例、来源和更新时间"],
      ["结构化信息", "FAQ、Organization、Product、Article 与可解析表格"],
      ["AI 引用准备度", "关键主张具备原始来源、发布日期和稳定页面"],
      ["AI 引荐追踪", "区分 AI 引荐、自然搜索、品牌搜索及后续有效动作"],
    ],
    metric: "搜索 / AI 引荐到有效动作率",
    guardrail: "有效咨询质量、商机贡献与错误引用",
    stop: "可见性上升，但有效动作无改善或错误引用增加",
  },
};

function baseChannel({
  name,
  stage,
  role,
  entry,
  exit,
  themes,
  formats,
  proof,
  cta,
  testBatch,
  actionGoal,
  audience,
  actionMatrix,
  budgetRule,
  exclusions,
  metric,
  guardrail,
  stop,
  executionLabel = "渠道动作怎么做",
}) {
  return {
    name,
    stage,
    role,
    entry,
    exit,
    depth: "BASE",
    executionLabel,
    content: [
      ["主题", themes],
      ["形式", formats],
      ["证据", proof],
      ["CTA", cta],
      ["测试批次", testBatch],
    ],
    paid: [
      ["目标", actionGoal],
      ["对象", audience],
      ["动作矩阵", actionMatrix],
      ["资源上限", budgetRule],
      ["排除条件", exclusions],
    ],
    metric,
    guardrail,
    stop,
  };
}

Object.assign(CHANNEL_STRATEGY_CONTRACTS, {
  DEEP_CONTENT: baseChannel({
    name: "B站 / 知乎",
    stage: "理解你 → 相信你",
    role: "用深度内容解释复杂价值，并形成可持续搜索的专业证据。",
    entry: "问题搜索、测评、教程或行业议题",
    exit: "品牌搜索、官网、咨询或交易入口",
    themes: "测评、教程、问题解释、案例和产品比较",
    formats: "长视频、回答、专栏与直播",
    proof: "可复核测试、专家来源、案例边界与产品事实",
    cta: "搜索品牌、访问官网或发起咨询",
    testBatch: "议题 × 内容深度 × CTA",
    actionGoal: "有效咨询和高质量搜索进入",
    audience: "主动研究与比较的潜在客户",
    actionMatrix: "问题议题 × 证据类型 × 承接页面",
    budgetRule: "先验证内容到有效咨询，再扩大制作投入",
    exclusions: "泛热点、无来源观点和低相关流量",
    metric: "深度内容到有效咨询率",
    guardrail: "咨询质量、制作成本与成交周期",
    stop: "观看和收藏增加，但有效咨询持续不足",
  }),
  OFFLINE_DISTRIBUTION: baseChannel({
    name: "线下门店 / 经销",
    stage: "相信你 → 体验 → 完成购买",
    role: "通过真实体验、导购和渠道覆盖完成线下选择。",
    entry: "门店到访、经销终端、区域活动或线上引流",
    exit: "体验、咨询、成交、退货和会员沉淀",
    themes: "产品体验、场景演示、门店服务和购买保障",
    formats: "陈列、导购话术、体验活动与区域物料",
    proof: "体验记录、真实库存、服务承诺和售后边界",
    cta: "到店体验、预约或购买",
    testBatch: "门店 / 区域 × 客群 × 体验动作",
    actionGoal: "有效到店、体验和成交",
    audience: "门店覆盖范围内的目标客户",
    actionMatrix: "门店 × 陈列 × 导购 × 体验",
    budgetRule: "按单店贡献和库存护栏配置资源",
    exclusions: "低适配商圈、无承接能力门店和高库存风险组合",
    metric: "到店成交率 / 单店贡献",
    guardrail: "毛利、退货、库存和体验质量",
    stop: "覆盖或客流增加，但单店贡献和库存效率恶化",
    executionLabel: "门店与经销动作",
  }),
  DOUYIN_LOCAL: baseChannel({
    name: "抖音本地生活",
    stage: "看到你 → 到店意愿",
    role: "让附近客户发现门店，并把内容兴趣转成可核销到店。",
    entry: "门店内容、达人探店、直播和团购",
    exit: "团购、导航、预约、核销或到店",
    themes: "门店场景、真实体验、产品与服务差异",
    formats: "短视频、探店、直播与团购页",
    proof: "真实门店、价格、体验和履约边界",
    cta: "导航、预约、团购或到店",
    testBatch: "门店 × 内容主题 × 团购权益",
    actionGoal: "有效到店和核销",
    audience: "门店商圈内的目标客群",
    actionMatrix: "内容 × 达人 × 团购 × 门店承接",
    budgetRule: "按有效到店和单店贡献设上限",
    exclusions: "无承接能力门店、低毛利权益和高退款客群",
    metric: "有效到店成本",
    guardrail: "核销毛利、退款和门店承接质量",
    stop: "团购和曝光增加，但有效到店或毛利恶化",
  }),
  LOCAL_REPUTATION: baseChannel({
    name: "口碑与到店搜索",
    stage: "理解你 → 比较 → 到店",
    role: "通过评价、场景内容和门店信息影响本地客户比较。",
    entry: "小红书场景内容、评价和本地搜索",
    exit: "收藏、导航、电话、预约或到店",
    themes: "真实体验、选择标准、门店差异与服务证据",
    formats: "图文、短视频、评价回复与门店页",
    proof: "真实评价、门店信息和服务记录",
    cta: "导航、预约或到店",
    testBatch: "商圈 × 场景词 × 门店页",
    actionGoal: "搜索到店和有效预约",
    audience: "正在比较本地选择的客户",
    actionMatrix: "场景内容 × 评价 × 门店承接",
    budgetRule: "先保证门店信息和评价质量，再扩大内容",
    exclusions: "虚假评价、无关流量和不可履约承诺",
    metric: "搜索到店率",
    guardrail: "到店质量、客单和满意度",
    stop: "收藏和导航增加，但真实到店没有变化",
  }),
  BAIDU_MAP: baseChannel({
    name: "百度搜索 / 地图",
    stage: "主动寻找 → 到店",
    role: "承接明确的附近需求、品牌查找和门店导航。",
    entry: "品牌词、品类词、附近需求与地图结果",
    exit: "电话、导航、预约或到店",
    themes: "门店信息、品类问题、位置和服务能力",
    formats: "搜索结果、地图门店页和本地落地页",
    proof: "准确地址、营业信息、评价和服务边界",
    cta: "电话、导航或预约",
    testBatch: "关键词 × 商圈 × 门店页",
    actionGoal: "有效导航、电话与到店",
    audience: "具有明确附近需求的客户",
    actionMatrix: "关键词 × 地图信息 × 门店承接",
    budgetRule: "按有效到店而非点击设上限",
    exclusions: "错误位置、无效词和无法承接时段",
    metric: "搜索到店成本",
    guardrail: "有效客流、成交和单店贡献",
    stop: "搜索动作增加，但门店有效客流未改善",
  }),
  WECHAT_MEMBER: baseChannel({
    name: "微信会员",
    stage: "完成购买 → 再次选择",
    role: "通过会员识别和价值触达促进复购与再次到店。",
    entry: "企微、公众号、小程序、社群和会员权益",
    exit: "预约、到店、复购、续费或退订",
    themes: "会员价值、使用提醒、服务内容和复购场景",
    formats: "企微触达、公众号、小程序与社群",
    proof: "会员权益、服务记录和历史购买",
    cta: "预约、复购或续费",
    testBatch: "会员分层 × 触达内容 × 价值节点",
    actionGoal: "会员复购和高质量回店",
    audience: "不同生命周期的存量客户",
    actionMatrix: "客户阶段 × 内容 × 权益 × 响应动作",
    budgetRule: "按复购贡献和退订护栏配置资源",
    exclusions: "无授权触达、频繁骚扰和低适配权益",
    metric: "会员复购率",
    guardrail: "退订、客单、满意度和毛利",
    stop: "触达增加，但复购、客单或满意度下降",
  }),
  POS: baseChannel({
    name: "外卖 / 本地生活平台",
    stage: "主动寻找 → 即时交易",
    role: "承接附近需求、团购核销和即时订单。",
    entry: "门店搜索、推荐、团购和外卖入口",
    exit: "下单、核销、退款、评价和复购",
    themes: "商品、门店、配送、团购和履约说明",
    formats: "门店页、商品页、团购页与评价",
    proof: "价格、库存、配送、评价和售后边界",
    cta: "下单、团购或到店核销",
    testBatch: "平台 × 门店 × 商品 / 权益",
    actionGoal: "有效订单和平台净贡献",
    audience: "附近即时需求和到店需求人群",
    actionMatrix: "商品 × 活动 × 门店 × 履约",
    budgetRule: "按佣金后贡献和退款护栏限制",
    exclusions: "低毛利商品、高退款权益和超出履约范围订单",
    metric: "核销成本 / 平台净贡献",
    guardrail: "佣金后贡献、退款、履约和复购",
    stop: "平台订单增加，但佣金后贡献或复购恶化",
  }),
  RETAIL_ECOMMERCE: { ...CHANNEL_STRATEGY_CONTRACTS.TRANSACTION, name: "平台电商", depth: "BASE" },
  RETAIL_PARTNER: baseChannel({
    name: "异业合作 / 商圈渠道",
    stage: "看到你 → 到店 / 交易",
    role: "通过合作品牌、企业和商圈关系获得新增客流。",
    entry: "联名、企业团购、商圈活动和合作权益",
    exit: "领券、预约、核销、到店或交易",
    themes: "联合场景、共同客群价值和合作权益",
    formats: "联名活动、券码、企业团购和商圈传播",
    proof: "合作主体、权益边界和真实核销",
    cta: "领券、预约或核销",
    testBatch: "合作方 × 客群 × 权益",
    actionGoal: "新增客户和有效核销",
    audience: "合作方可识别的高相关客群",
    actionMatrix: "合作方 × 权益 × 门店 / 商品",
    budgetRule: "按新增客户和核销贡献设上限",
    exclusions: "客群重叠过高、低毛利权益和无法去重渠道",
    metric: "合作渠道有效到店成本",
    guardrail: "新增客户占比、客单、复购和毛利",
    stop: "核销增加，但新增客户、客单或复购没有改善",
  }),
  STORE_NETWORK: baseChannel({
    name: "门店自然客流",
    stage: "到店 → 体验 → 完成购买",
    role: "优化商圈、门店触点、陈列、导购和现场成交。",
    entry: "自然客流、品牌到店、路过和老客回店",
    exit: "体验、咨询、成交、退货和会员沉淀",
    themes: "门店体验、商品组合、陈列和服务",
    formats: "橱窗、动线、陈列、导购与现场体验",
    proof: "真实商品、库存、价格和服务能力",
    cta: "体验、咨询、购买或加入会员",
    testBatch: "门店 × 时段 × 陈列 / 导购动作",
    actionGoal: "进店成交和单店贡献",
    audience: "门店真实客流与商圈目标客户",
    actionMatrix: "门店 × 动线 × 陈列 × 导购",
    budgetRule: "按单店贡献、库存和人效配置资源",
    exclusions: "低适配商圈、缺货商品和不可执行门店",
    metric: "进店成交率 / 单店贡献",
    guardrail: "毛利、库存、人效和体验质量",
    stop: "进店或成交改善，但毛利、库存或体验恶化",
    executionLabel: "门店经营动作",
  }),
  BAIDU_B2B: { ...CHANNEL_STRATEGY_CONTRACTS.BAIDU, name: "百度搜索", depth: "BASE", metric: "有效商机成本", guardrail: "商机质量、赢单率和合同贡献" },
  WECHAT_B2B: { ...CHANNEL_STRATEGY_CONTRACTS.WECHAT, name: "微信生态", depth: "BASE", metric: "商机推进率", guardrail: "销售周期、商机质量和退订" },
  CONTENT_B2B: baseChannel({
    name: "B站 / 知乎 / 行业内容",
    stage: "理解你 → 相信你",
    role: "解释复杂方案价值并建立企业客户需要的专业可信度。",
    entry: "行业议题、问题搜索、白皮书和活动内容",
    exit: "下载、报名、咨询、会议或官网",
    themes: "行业问题、解决方案、案例和方法论",
    formats: "长视频、回答、白皮书、直播和研讨会内容",
    proof: "客户案例、来源数据、适用边界和能力证据",
    cta: "下载、报名、咨询或预约会议",
    testBatch: "行业议题 × 决策角色 × 证据类型",
    actionGoal: "目标账户进入和有效商机",
    audience: "目标行业、岗位和账户角色",
    actionMatrix: "议题 × 角色 × 内容 × 承接动作",
    budgetRule: "按有效商机而非下载量配置资源",
    exclusions: "非目标行业、低质量名单和无证据内容",
    metric: "内容到有效商机率",
    guardrail: "目标账户质量、销售周期和赢单率",
    stop: "内容触达增加，但目标客户和有效商机没有增加",
  }),
  SALES_OUTBOUND: baseChannel({
    name: "销售主动触达",
    stage: "识别账户 → 建立对话 → 商机",
    role: "直接寻找并验证高价值目标账户与真实需求。",
    entry: "目标账户名单、公开需求与业务信号",
    exit: "回复、会议、商机、方案或合同",
    themes: "客户问题、诊断假设、案例和价值证据",
    formats: "邮件、电话、社交触达、诊断会与方案跟进",
    proof: "账户事实、案例、需求证据与交付边界",
    cta: "回复、预约会议或接受诊断",
    testBatch: "账户分层 × 角色 × 触达序列",
    actionGoal: "有效回复、会议和商机",
    audience: "满足 ICP 条件的目标账户与决策角色",
    actionMatrix: "账户信号 × 角色 × 话术 × 跟进动作",
    budgetRule: "按销售人时和有效商机设置上限",
    exclusions: "非 ICP 账户、重复骚扰和无来源名单",
    metric: "目标账户转商机率",
    guardrail: "销售人效、商机质量和品牌风险",
    stop: "触达量增加，但回复、会议或有效商机持续不足",
    executionLabel: "销售执行动作",
  }),
  CRM: { ...CHANNEL_STRATEGY_CONTRACTS.OWNED_SITE, name: "官网 / SEO / GEO", depth: "BASE", metric: "官网 / AI 引荐到有效商机率", guardrail: "商机质量、错误引用和合同贡献" },
  INDUSTRY_EVENT: baseChannel({
    name: "行业活动 / 会议",
    stage: "看到你 → 深度交流 → 商机",
    role: "集中触达目标角色，并通过高密度交流建立信任。",
    entry: "展会、闭门会、研讨会和行业演讲",
    exit: "到场、会议、跟进、商机和方案",
    themes: "行业问题、客户案例、方法和解决方案",
    formats: "演讲、圆桌、展台、闭门会和会后内容",
    proof: "嘉宾、议题、案例和现场交流记录",
    cta: "预约会谈、接受诊断或进入商机",
    testBatch: "活动 × 目标账户 × 会后跟进路径",
    actionGoal: "目标账户到场和有效会议",
    audience: "目标行业、账户和决策角色",
    actionMatrix: "活动 × 议题 × 邀约 × 会后跟进",
    budgetRule: "按有效会议和商机而非名片数配置资源",
    exclusions: "非目标受众、无跟进能力活动和虚假到场",
    metric: "参会目标账户转商机率",
    guardrail: "有效会议质量、销售周期和活动成本",
    stop: "到场和名片增加，但有效会议或商机不足",
    executionLabel: "活动与跟进动作",
  }),
  CHANNEL_PARTNER: baseChannel({
    name: "渠道伙伴 / 经销商",
    stage: "伙伴覆盖 → 客户接触 → 商机 / 成交",
    role: "借助合作伙伴覆盖客户、区域和交付场景。",
    entry: "伙伴招募、联合方案、转介绍和区域网络",
    exit: "伙伴线索、商机、合同、回款或续约",
    themes: "联合价值、客户场景、伙伴收益和交付规则",
    formats: "伙伴手册、联合方案、培训和联合活动",
    proof: "伙伴资质、客户案例、分工和利益边界",
    cta: "注册伙伴、提交线索或联合跟进",
    testBatch: "伙伴类型 × 区域 × 联合方案",
    actionGoal: "活跃伙伴、有效商机和渠道贡献",
    audience: "具备目标客户覆盖与交付能力的伙伴",
    actionMatrix: "伙伴 × 联合方案 × 线索 × 跟进",
    budgetRule: "按活跃伙伴和有效商机配置支持",
    exclusions: "无客户覆盖、利益冲突和不可追溯线索",
    metric: "伙伴有效商机 / 渠道贡献",
    guardrail: "活跃率、分成后贡献、回款和客户质量",
    stop: "伙伴数量增加，但活跃伙伴和有效商机不足",
    executionLabel: "伙伴运营动作",
  }),
});

function lever({
  id,
  label,
  unit,
  min,
  max,
  step,
  defaultValue,
  impact,
  watch,
  recommendation,
}) {
  return { id, label, unit, min, max, step, defaultValue, impact, watch, recommendation };
}

const CHANNEL_CONTROL_PRESETS = {
  DOUYIN: [
    lever({ id: "content_batches", label: "本批测试内容组数", unit: "组", min: 1, max: 8, step: 1, defaultValue: 3, impact: "找到真正带来有效进入的内容主题", watch: "每组内容的有效进入数与成本", recommendation: "先做 3 组，每组只改变一个主题或证据，不要一次混改。" }),
    lever({ id: "audience_groups", label: "并行测试人群数", unit: "组", min: 1, max: 6, step: 1, defaultValue: 2, impact: "收紧或扩大目标客户范围", watch: "不同人群的有效咨询率", recommendation: "先比较 2 组高相关人群，播放量不是放量依据。" }),
    lever({ id: "response_minutes", label: "高意向客户响应上限", unit: "分钟", min: 5, max: 120, step: 5, defaultValue: 30, impact: "减少从兴趣到下一动作的流失", watch: "响应后完成咨询或留资的比例", recommendation: "先把响应上限控制在 30 分钟内，再判断是否值得扩量。" }),
  ],
  XHS: [
    lever({ id: "query_clusters", label: "本批问题词簇", unit: "组", min: 1, max: 10, step: 1, defaultValue: 3, impact: "覆盖客户真实搜索和比较问题", watch: "词簇带来的品牌搜索与有效咨询", recommendation: "先选 3 组高意向问题词，不用泛流量词填满目录。" }),
    lever({ id: "evidence_formats", label: "每个词簇的证据形式", unit: "种", min: 1, max: 5, step: 1, defaultValue: 2, impact: "提升客户理解与可信度", watch: "收藏后搜索、私信或进入承接页", recommendation: "每个词簇至少比较体验证据和产品证据两种形式。" }),
    lever({ id: "notes_per_batch", label: "每个词簇测试笔记", unit: "篇", min: 1, max: 8, step: 1, defaultValue: 3, impact: "增加有效内容样本而非单篇押注", watch: "单篇有效进入与咨询质量", recommendation: "先以 3 篇形成小样本，确认有效词簇后再增加数量。" }),
  ],
  BAIDU: [
    lever({ id: "keyword_groups", label: "本批高意向关键词组", unit: "组", min: 1, max: 12, step: 1, defaultValue: 4, impact: "把预算集中到明确需求", watch: "每组词的有效咨询成本", recommendation: "先做品牌、品类、问题、比较 4 组，分别核算结果。" }),
    lever({ id: "negative_coverage", label: "无效词排除覆盖", unit: "%", min: 0, max: 100, step: 5, defaultValue: 70, impact: "减少低相关点击和预算浪费", watch: "无效点击率与有效咨询率", recommendation: "先覆盖已知无效词的 70%，每批根据搜索词报告继续补充。" }),
    lever({ id: "landing_variants", label: "承接页版本数", unit: "版", min: 1, max: 5, step: 1, defaultValue: 2, impact: "验证客户需要哪类证据才会行动", watch: "落地页到有效咨询率", recommendation: "先比较 2 版：问题解释版与案例证据版，避免同时改关键词。" }),
  ],
  WECHAT: [
    lever({ id: "customer_segments", label: "本批客户分层数", unit: "层", min: 1, max: 8, step: 1, defaultValue: 3, impact: "减少对所有客户使用同一内容", watch: "各分层咨询、复购或续约率", recommendation: "先按新客、意向客、已成交客户分 3 层，不做无差别群发。" }),
    lever({ id: "touch_frequency", label: "每个业务周期触达上限", unit: "次", min: 1, max: 10, step: 1, defaultValue: 3, impact: "平衡持续解释和客户打扰", watch: "有效响应、退订与投诉", recommendation: "先设置 3 次上限；无响应时调整内容，不继续叠加频次。" }),
    lever({ id: "followup_hours", label: "有效咨询跟进上限", unit: "小时", min: 1, max: 72, step: 1, defaultValue: 12, impact: "缩短客户从信任到行动的等待", watch: "跟进后的有效下一步完成率", recommendation: "先要求 12 小时内完成首次有效跟进，并记录主要异议。" }),
  ],
  TRANSACTION: [
    lever({ id: "product_variants", label: "本批商品 / 权益组合", unit: "组", min: 1, max: 8, step: 1, defaultValue: 3, impact: "识别客户真正愿意购买的组合", watch: "支付率、客单和单客贡献", recommendation: "先测试 3 组差异明确的商品或权益，不用连续折扣掩盖价值问题。" }),
    lever({ id: "detail_evidence", label: "详情页关键证据模块", unit: "个", min: 1, max: 10, step: 1, defaultValue: 4, impact: "减少支付前的不确定与误解", watch: "详情页到支付率和退款原因", recommendation: "先补齐参数、场景、评价和售后边界 4 类证据。" }),
    lever({ id: "service_minutes", label: "高意向客服响应上限", unit: "分钟", min: 1, max: 60, step: 1, defaultValue: 10, impact: "减少购买前咨询流失", watch: "咨询到支付率与售后问题", recommendation: "先把高意向咨询响应控制在 10 分钟内，同时观察退款是否增加。" }),
  ],
  OWNED_SITE: [
    lever({ id: "query_clusters", label: "首批问题词簇", unit: "组", min: 1, max: 12, step: 1, defaultValue: 4, impact: "覆盖搜索和 AI 问答中的真实需求", watch: "词簇可见性、引用与有效咨询", recommendation: "先选 4 组与成交问题直接相关的词簇，不追求全行业覆盖。" }),
    lever({ id: "evidence_pages", label: "实体证据页面", unit: "页", min: 1, max: 20, step: 1, defaultValue: 5, impact: "让搜索与 AI 能理解并引用企业能力", watch: "页面收录、AI 引用与后续有效动作", recommendation: "先完成企业、产品、案例、能力和边界 5 类稳定证据页。" }),
    lever({ id: "tracked_ctas", label: "可追踪 CTA 数", unit: "个", min: 1, max: 8, step: 1, defaultValue: 3, impact: "把可见性连接到真实客户动作", watch: "AI / 搜索引荐到咨询、试用或交易", recommendation: "至少区分咨询、试用、购买 3 类动作，并保留来源参数。" }),
  ],
  STORE: [
    lever({ id: "pilot_stores", label: "首批试点门店", unit: "家", min: 1, max: 20, step: 1, defaultValue: 3, impact: "用可控门店样本验证动作", watch: "单店客流、成交率和贡献", recommendation: "先选 3 家基础条件相近的门店，保留未调整门店作为比较。" }),
    lever({ id: "experience_actions", label: "每店体验 / 陈列动作", unit: "项", min: 1, max: 8, step: 1, defaultValue: 2, impact: "验证现场触点是否推动客户选择", watch: "体验完成率与进店成交率", recommendation: "每店先改 2 项，避免陈列、导购、价格和权益同时变化。" }),
    lever({ id: "staff_coverage", label: "执行员工覆盖", unit: "%", min: 10, max: 100, step: 10, defaultValue: 70, impact: "保证测试动作真实发生", watch: "执行覆盖、导购记录和成交质量", recommendation: "先达到 70% 执行覆盖；动作未执行时不能判断渠道无效。" }),
  ],
  SALES_OUTBOUND: [
    lever({ id: "target_accounts", label: "首批目标账户", unit: "家", min: 10, max: 200, step: 10, defaultValue: 50, impact: "控制销售验证样本和人力投入", watch: "有效回复、会议和商机数", recommendation: "先以 50 家高匹配账户验证，不用大名单掩盖 ICP 问题。" }),
    lever({ id: "contact_roles", label: "每个账户触达角色", unit: "类", min: 1, max: 5, step: 1, defaultValue: 2, impact: "减少只触达单一角色造成的判断偏差", watch: "不同角色的回复和会议率", recommendation: "先比较业务决策人与使用影响者两类角色。" }),
    lever({ id: "sequence_steps", label: "单账户跟进动作上限", unit: "步", min: 1, max: 8, step: 1, defaultValue: 4, impact: "平衡充分解释和过度触达", watch: "每一步新增回复与退订 / 拒绝", recommendation: "先设 4 步上限；连续无新增回应时停止该序列。" }),
  ],
  EVENT: [
    lever({ id: "target_accounts", label: "重点邀约账户", unit: "家", min: 10, max: 200, step: 10, defaultValue: 40, impact: "让活动资源集中于目标客户", watch: "目标账户到场与有效会议", recommendation: "先锁定 40 家高匹配账户，不以总报名量替代目标到场。" }),
    lever({ id: "core_topics", label: "核心议题", unit: "个", min: 1, max: 6, step: 1, defaultValue: 2, impact: "提高活动内容与客户问题的相关性", watch: "议题参与、会后咨询和会议", recommendation: "先聚焦 2 个客户正在决策的问题，避免议程过宽。" }),
    lever({ id: "followup_hours", label: "会后首次跟进上限", unit: "小时", min: 4, max: 96, step: 4, defaultValue: 24, impact: "把现场兴趣转成可识别商机", watch: "跟进完成率和有效会议率", recommendation: "24 小时内完成分层跟进，并记录未推进原因。" }),
  ],
  PARTNER: [
    lever({ id: "pilot_partners", label: "首批试点伙伴", unit: "家", min: 1, max: 20, step: 1, defaultValue: 3, impact: "验证伙伴覆盖和合作意愿", watch: "活跃伙伴、有效线索和商机", recommendation: "先选 3 家能力与客群不同的伙伴，不以签约数量判断有效。" }),
    lever({ id: "joint_offers", label: "联合方案", unit: "套", min: 1, max: 6, step: 1, defaultValue: 2, impact: "确认客户是否理解联合价值", watch: "方案使用、客户回应和商机质量", recommendation: "先形成 2 套针对不同客户问题的联合方案。" }),
    lever({ id: "lead_sla_hours", label: "伙伴线索响应上限", unit: "小时", min: 1, max: 72, step: 1, defaultValue: 12, impact: "减少伙伴线索在交接中流失", watch: "线索接受、首次联系和商机推进", recommendation: "先承诺 12 小时内确认线索归属和下一责任人。" }),
  ],
  DEEP_CONTENT: [
    lever({ id: "core_topics", label: "首批核心议题", unit: "个", min: 1, max: 8, step: 1, defaultValue: 3, impact: "聚焦客户真正需要理解的问题", watch: "深度阅读、品牌搜索和有效咨询", recommendation: "先做 3 个直接影响选择的议题，不追逐泛热点。" }),
    lever({ id: "proof_assets", label: "每个议题证据资产", unit: "个", min: 1, max: 6, step: 1, defaultValue: 2, impact: "让专业表达具有可验证依据", watch: "证据内容后的咨询质量", recommendation: "每个议题至少准备案例和原始来源两类证据。" }),
    lever({ id: "tracked_ctas", label: "可追踪下一动作", unit: "个", min: 1, max: 5, step: 1, defaultValue: 2, impact: "把内容价值连接到客户行动", watch: "内容到咨询、下载或会议", recommendation: "先保留 2 个明确动作，避免一个页面放置过多出口。" }),
  ],
};

const CONTROL_PRESET_ALIASES = {
  DOUYIN_LOCAL: "DOUYIN",
  LOCAL_REPUTATION: "XHS",
  BAIDU_MAP: "BAIDU",
  WECHAT_MEMBER: "WECHAT",
  POS: "TRANSACTION",
  RETAIL_ECOMMERCE: "TRANSACTION",
  OFFLINE_DISTRIBUTION: "STORE",
  STORE_NETWORK: "STORE",
  BAIDU_B2B: "BAIDU",
  WECHAT_B2B: "WECHAT",
  CRM: "OWNED_SITE",
  CONTENT_B2B: "DEEP_CONTENT",
  INDUSTRY_EVENT: "EVENT",
  CHANNEL_PARTNER: "PARTNER",
  RETAIL_PARTNER: "PARTNER",
};

export function getChannelControlPresets(channelId) {
  const presetId = CONTROL_PRESET_ALIASES[channelId] ?? channelId;
  return CHANNEL_CONTROL_PRESETS[presetId] ?? CHANNEL_CONTROL_PRESETS.DEEP_CONTENT;
}

const CHANNEL_DECISION_PROFILES = {
  DOUYIN: {
    stance: "先验证内容能否带来有效进入，暂不按播放量扩大预算。",
    first: "先做 3 组问题场景内容，每组只改变一个主题或证据，并统一承接入口。",
    pause: "暂停泛兴趣扩量、达人数量堆叠和多变量同时改动。",
    gate: "至少两个可比批次的有效进入成本改善，且成交质量与退款护栏不恶化。",
  },
  XHS: {
    stance: "先用问题词和真实证据建立比较优势，不把收藏量当作增长结果。",
    first: "优先验证高意向问题词、使用证据和品牌搜索之间是否形成连续路径。",
    pause: "暂停泛生活方式内容、无来源体验表达和只追求互动的投放。",
    gate: "品牌搜索或有效咨询出现可重复改善，且咨询质量与投诉不恶化。",
  },
  BAIDU: {
    stance: "先收紧高意向词并修复承接页，不建议用泛词换取便宜点击。",
    first: "按品牌、品类、问题、比较四类词分组，补齐否定词，并比较两版承接页。",
    pause: "暂停泛词扩量、只看点击成本和多个词簇共用同一承接页。",
    gate: "高意向词的有效咨询成本连续改善，且无效线索率与成交贡献不恶化。",
  },
  WECHAT: {
    stance: "先按客户阶段分层承接，不建议增加无差别触达频次。",
    first: "先区分新客、意向客和已成交客户，给每层设置一个明确下一动作。",
    pause: "暂停群发堆量、重复催促和没有客户授权的触达。",
    gate: "有效咨询、复购或续约率改善，且退订、投诉与响应成本不恶化。",
  },
  TRANSACTION: {
    stance: "先修复商品证据和支付前阻力，不用折扣掩盖客户不选择的原因。",
    first: "比较 3 组差异明确的商品或权益，并补齐参数、场景、评价和售后边界。",
    pause: "暂停连续降价、低毛利扩量和只看支付订单不看退款。",
    gate: "有效支付与单客贡献共同改善，且退款和履约风险不恶化。",
  },
  OWNED_SITE: {
    stance: "先建设可引用的证据页面和可追踪入口，不追求没有业务动作的可见性。",
    first: "先完成高意向问题词簇、五类实体证据页和可区分来源的咨询或试用入口。",
    pause: "暂停批量薄内容、无来源主张和只统计收录或 AI 引用次数。",
    gate: "搜索或 AI 引荐带来有效动作，且错误引用、商机质量与成交贡献不恶化。",
  },
  STORE: {
    stance: "先用少量可比门店验证现场动作，不建议全门店同步铺开。",
    first: "选择 3 家基础相近门店，逐店验证陈列、体验或导购动作，并保留比较门店。",
    pause: "暂停全网点推广、价格与陈列同时调整，以及执行未发生时判断门店无效。",
    gate: "试点门店成交率或单店贡献改善，且毛利、库存、退货与体验质量不恶化。",
  },
  SALES_OUTBOUND: {
    stance: "先验证高匹配账户和决策角色，不建议用大名单掩盖客户定义问题。",
    first: "先用 50 家高匹配账户比较决策人和使用影响者两类角色的真实回应。",
    pause: "暂停非目标账户扩量、重复骚扰和只统计发送量。",
    gate: "有效回复、会议和商机连续改善，且销售人效与品牌风险不恶化。",
  },
  EVENT: {
    stance: "先聚焦目标账户和会后推进，不以总报名量判断活动有效。",
    first: "锁定高匹配账户和两个核心议题，并在会后 24 小时内完成分层跟进。",
    pause: "暂停泛人群拉新、议题过宽和没有责任人的会后名单。",
    gate: "目标账户到场、有效会议和商机推进改善，且活动成本与销售周期可接受。",
  },
  PARTNER: {
    stance: "先验证少量活跃伙伴和真实商机，不把签约伙伴数当作渠道增长。",
    first: "先选 3 家能力和客群不同的伙伴，明确联合方案、线索归属和响应时限。",
    pause: "暂停大规模招募、无客户覆盖伙伴和不可追溯的线索分配。",
    gate: "活跃伙伴、有效商机和渠道贡献改善，且分成后贡献与回款不恶化。",
  },
  DEEP_CONTENT: {
    stance: "先用少量核心议题建立可信证据，不追逐与成交无关的泛热点。",
    first: "先做 3 个直接影响客户选择的议题，每个议题绑定案例、来源和下一动作。",
    pause: "暂停无来源观点、只追求观看收藏和没有承接入口的内容。",
    gate: "深度内容带来的有效咨询改善，且制作成本、咨询质量与成交周期不恶化。",
  },
};

export function getChannelDecisionProfile(channelId) {
  const profileId = CONTROL_PRESET_ALIASES[channelId] ?? channelId;
  return CHANNEL_DECISION_PROFILES[profileId] ?? CHANNEL_DECISION_PROFILES.DEEP_CONTENT;
}

export function buildChannelCombination(primaryId, supportId, objective) {
  const primary = CHANNEL_STRATEGY_CONTRACTS[primaryId];
  const support = CHANNEL_STRATEGY_CONTRACTS[supportId];
  if (!primary || !support || primaryId === supportId) return null;
  return {
    primary,
    support,
    path: `${primary.name} → ${support.name}`,
    handoff: `在${primary.exit}记录统一来源与客户标识，再把高意向客户交给${support.name}的${support.entry}。`,
    measurement: "统一记录来源、首次有效动作、跨渠道辅助动作、最终成交和质量护栏。",
    attribution: "平台互动只作过程证据；最终结果以企业去重线索、订单、退款与利润为准。",
    strategyLevel: DIGITAL_CHANNEL_IDS.includes(primaryId) && DIGITAL_CHANNEL_IDS.includes(supportId) ? "DEEP" : "BASE",
    options: [
      {
        id: "RECOMMENDED",
        label: "推荐方案",
        title: "主渠道验证 + 协同承接",
        summary: `先用${primary.name}验证主要进入，再由${support.name}完成承接和质量复核。`,
        budget: "主渠道 65% · 协同渠道 35%",
        content: "内容 45% · 付费投放 55%",
        risk: "主渠道扩量速度超过协同渠道承接能力",
      },
      {
        id: "LOW_RISK",
        label: "低风险替代",
        title: "小批次证据优先",
        summary: `先确认${primary.name}到${support.name}的真实转移，再决定是否增加预算。`,
        budget: "主渠道 55% · 协同渠道 45%",
        content: "内容 65% · 付费投放 35%",
        risk: "样本成熟较慢，短期无法判断规模潜力",
      },
      {
        id: "NO_ACTION",
        label: "不行动基线",
        title: "保持结构，先补统一基线",
        summary: "不增加测试预算，只补齐两个渠道的投入、有效客户和成交质量口径。",
        budget: "不新增预算",
        content: "只完成数据治理",
        risk: `继续承担当前“${objective.short}”的损耗，且无法判断组合是否更优`,
      },
    ],
  };
}

export function simulateChannelControl({
  baseline,
  totalBudget,
  primaryShare,
  contentShare,
  l2Enabled,
  selectedOption,
}) {
  const allocation = {
    primaryBudget: totalBudget * primaryShare,
    supportBudget: totalBudget * (1 - primaryShare),
    contentBudget: totalBudget * contentShare,
    paidBudget: totalBudget * (1 - contentShare),
  };
  const directional = [
    primaryShare >= 0.6 ? "资源更集中于主渠道验证" : "协同渠道承担更多承接资源",
    contentShare >= 0.5 ? "更偏向内容与证据建设" : "更偏向付费触达测试",
    selectedOption === "NO_ACTION" ? "当前仅建立可比基线" : "等待真实行动数据判断客户数量、成本与质量变化",
  ];
  if (!l2Enabled) return { allocation, directional, scenarios: null };

  const baseEntries = baseline.traffic * baseline.entryRate / 100;
  const baseCustomers = baseEntries * baseline.choiceRate / 100;
  const baseRefundRate = baseline.refundRate / 100;
  const assumptions = {
    conservative: { label: "保守", entry: 0.98, choice: 1.01, contribution: 0.98, refund: 1.08 },
    base: { label: "中性", entry: 1.08, choice: 1.08, contribution: 1, refund: 1 },
    aggressive: { label: "进取", entry: 1.2, choice: 1.15, contribution: 0.9, refund: 1.3 },
  };
  const scenarios = Object.fromEntries(Object.entries(assumptions).map(([key, item]) => {
    if (selectedOption === "NO_ACTION") {
      return [key, {
        label: item.label,
        customers: baseCustomers,
        choiceRate: baseline.choiceRate / 100,
        cac: baseCustomers > 0 ? baseline.spend / baseCustomers : 0,
        contribution: baseCustomers * baseline.contribution - baseline.spend,
        refundRate: baseRefundRate,
        warning: "不行动基线不代表未来保持不变",
      }];
    }
    const spendScale = baseline.spend > 0 ? totalBudget / baseline.spend : 0;
    const entries = baseEntries * spendScale * item.entry;
    const choiceRate = Math.min(1, baseline.choiceRate / 100 * item.choice);
    const customers = entries * choiceRate;
    const contribution = customers * baseline.contribution * item.contribution - totalBudget;
    const refundRate = Math.min(1, baseRefundRate * item.refund);
    const baseCac = baseCustomers > 0 ? baseline.spend / baseCustomers : 0;
    const cac = customers > 0 ? totalBudget / customers : 0;
    return [key, {
      label: item.label,
      customers,
      choiceRate,
      cac,
      contribution,
      refundRate,
      warning: cac < baseCac && (refundRate > baseRefundRate || contribution < baseCustomers * baseline.contribution - baseline.spend)
        ? "成本改善，但质量或贡献护栏恶化"
        : "",
    }];
  }));
  return { allocation, directional, scenarios };
}
